(() => {
  'use strict';
  if (customElements.get('enc-gallery')) return;

  class EncGallery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.slides = [...this.querySelectorAll('[data-ec-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-ec-thumb]')];
      this.status = this.querySelector('[data-ec-status]');
      this.dialog = this.querySelector('[data-ec-dialog]');
      this.dialogImage = this.querySelector('[data-ec-dialog-image]');
      this.index = 0;
      this.pointerStart = null;

      this.querySelector('[data-ec-prev]')?.addEventListener('click', () => this.show(this.index - 1, true));
      this.querySelector('[data-ec-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
      this.thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => this.show(index, false)));
      this.querySelectorAll('[data-ec-open]').forEach((button) => button.addEventListener('click', () => this.openDialog()));
      this.querySelector('[data-ec-close]')?.addEventListener('click', () => this.dialog?.close());

      this.addEventListener('keydown', (event) => {
        if (this.dialog?.open) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index - 1, true);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + 1, true);
        } else if (event.key === 'Home') {
          event.preventDefault();
          this.show(0, true);
        } else if (event.key === 'End') {
          event.preventDefault();
          this.show(this.slides.length - 1, true);
        }
      });

      const stage = this.querySelector('.ec-gallery__stage');
      stage?.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || event.pointerType === 'mouse') return;
        this.pointerStart = { x: event.clientX, y: event.clientY };
      }, { passive: true });
      stage?.addEventListener('pointerup', (event) => {
        if (!this.pointerStart || !event.isPrimary) return;
        const deltaX = event.clientX - this.pointerStart.x;
        const deltaY = event.clientY - this.pointerStart.y;
        this.pointerStart = null;
        if (Math.abs(deltaX) < 42 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        this.show(this.index + (deltaX < 0 ? 1 : -1), true);
      }, { passive: true });
      stage?.addEventListener('pointercancel', () => { this.pointerStart = null; }, { passive: true });

      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.show(0, false);
    }

    show(nextIndex, announce) {
      const count = this.slides.length;
      if (!count) return;
      this.index = (nextIndex + count) % count;
      this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; });
      this.thumbs.forEach((thumb, index) => {
        const active = index === this.index;
        thumb.classList.toggle('is-active', active);
        if (active) {
          thumb.setAttribute('aria-current', 'true');
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          thumb.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      if (this.status) {
        this.status.textContent = `Imagen ${this.index + 1} de ${count}`;
        if (!announce) this.status.setAttribute('aria-live', 'off');
        requestAnimationFrame(() => this.status?.setAttribute('aria-live', 'polite'));
      }
    }

    openDialog() {
      if (!this.dialog || !this.dialogImage) return;
      const currentImage = this.slides[this.index]?.querySelector('img');
      if (!currentImage) return;
      this.dialogImage.src = currentImage.currentSrc || currentImage.src;
      this.dialogImage.alt = currentImage.alt;
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
    }
  }

  customElements.define('enc-gallery', EncGallery);
})();
